import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Chart } from 'chart.js';
import { BonusqrService } from 'src/app/shared/servicio/bonusqr/bonusqr.service';
import { HelpersService } from 'src/app/shared/servicio/helpers/helpers.service';

@Component({
  selector: 'app-bonus-qr-performance',
  templateUrl: './bonus-qr-performance.component.html',
  styleUrls: ['./bonus-qr-performance.component.css'],
})
export class BonusQrPerformanceComponent implements OnInit {
  code: string;
  loading = true;
  performance: any;
  chart: Chart;

  constructor(private _route: ActivatedRoute, private _bonusqr: BonusqrService, public _helper: HelpersService) {}

  ngOnInit(): void {
    this.code = this._route.snapshot.paramMap.get('code');
    this.load();
  }

  load(): void {
    this.loading = true;
    this._bonusqr.getPerformance(this.code).subscribe(
      (data: any) => {
        this.performance = data;
        this.loading = false;
        setTimeout(() => this.initChart(data.by_month || []), 0);
      },
      () => {
        this.loading = false;
        this._helper.modalError('No se pudieron cargar las métricas');
      }
    );
  }

  private initChart(byMonth: { month: string; count: number }[]): void {
    Chart.defaults.global.defaultFontColor = '#452c80';
    Chart.defaults.global.defaultFontFamily = 'TTCommonsBold';

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart('chartBonusQrPerformance', {
      type: 'bar',
      data: {
        labels: byMonth.map((m) => m.month),
        datasets: [
          {
            data: byMonth.map((m) => m.count),
            label: 'Bonos por mes',
            backgroundColor: '#89d3ff',
            borderColor: 'white',
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: true },
        scales: {
          xAxes: [{ gridLines: { display: true } }],
          yAxes: [{ ticks: { beginAtZero: true } }],
        },
      },
    });
  }
}
